import { AppConfigModel } from "../abstract/app-config.model";

export class Civility extends AppConfigModel {

    static override CLASS_NAME: string = 'Civility';
}
